import { getGlobalObject } from "./global";
import get from "lodash-es/get";

const userAgent = get(getGlobalObject<Window>(), "navigator.userAgent");

const is12306Client = /mobile12306/i.test(userAgent);

// os
let iOS = false;
const ipad = userAgent.match(/(iPad).*OS\s([\d_]+)/);
const ipod = userAgent.match(/(iPod)(.*OS\s([\d_]+))?/);
const iphone = !ipad && userAgent.match(/(iPhone\sOS)\s([\d_]+)/);
const android = userAgent.match(/(Android);?[\s\/]+([\d.]+)?/);

let isAndroid = false;
let isIPhone = false;
let isIPad = false;
let isIPod = false;

// version
let deviceVersion = "";
android && (deviceVersion = android[2]) && (isAndroid = true);
iphone &&
  !ipod &&
  (deviceVersion = iphone[2].replace(/_/g, ".")) &&
  (iOS = isIPhone = true);
ipad && (deviceVersion = ipad[2].replace(/_/g, ".")) && (iOS = isIPad = true);
ipod &&
  (deviceVersion = ipod[3] ? ipod[3].replace(/_/g, ".") : "") &&
  (iOS = isIPod = true);

const deviceOS = iOS ? "ios" : isAndroid ? "android" : "web";

export {
  userAgent,
  deviceOS,
  is12306Client,
  deviceVersion,
  isIPad,
  isIPhone,
  isAndroid,
  isIPod,
};
